<div *ngIf="this.router.url !== '/authentication'">
</div>
<router-outlet></router-outlet>
<app-loader></app-loader>